import { useEffect } from "react";
import Sidebar from "../common/Sidebar";
import Logout from "../common/Logout";
import { Link } from "react-router-dom";

const Dashboard = () => {
  useEffect(() => {
    document.title = "Dashboard";
    window.scrollTo(0,0);
  }, []);
  return (
    <>
      <div className="main_section">
        <div className="main_flex">
          <div className="main_flexL">
            <Sidebar />
          </div>
          <div className="main_flexR">
            <div className="right_title">
              <h1>Dashboard</h1>
              <Logout />
            </div>
            <div className="dash_QuickLinks">
              <div className="dash_inner">
                <h1>Welcome Admin</h1>
                <h2>Quick Links</h2>
                <div className="dash_flex">
                  <div className="dash_fInner">
                    <Link to="/flexcare-bookings">
                      <button className="main_button">
                        Bookings <i className="fas fa-calendar-alt"></i>
                      </button>
                    </Link>
                  </div>
                  <div className="dash_fInner">
                    <Link to="/all-users">
                      <button className="main_button">
                        Users <i className="fas fa-users" />
                      </button>
                    </Link>
                  </div>
                  <div className="dash_fInner">
                    <Link to="/invoices">
                      <button className="main_button">
                        Invoices <i className="fas fa-print" />
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
